import { RepositoryUtils } from '../utils/RepositoryUtils';
import {
  EmailVerificationCheckType,
  EmailVerificationResponseType,
  IvyUsersMeType,
} from '../types/MemberTypes';
import {
    AdminCompanyEditResponseType,
    AdminCompanyInfoType,
    AdminCompanyListResponseType, AdminOccupationResultType,
    AdminRecruitmentEditResponseType,
    AdminRecruitmentRegisterType,
    AdminRecruitmentResultType,
    AdminRecruitmentType, AdminRegionResultType,
    AdminResumeListResponseType,
    AdminResumeType,
    AdminUserListResponseType,
} from '../types/AdminTypes';
import { MedeaType } from '../types/MedeaTypes';
import {ErrorType} from "../types/ErrorType";

const ivyApiDomain = process.env.REACT_APP_IVY_APP_SERVER_API_DOMAIN;

export const fetchAdminUsers = (name: string, page: number, size: number, token: string) => {
  return RepositoryUtils.axiosGet<AdminUserListResponseType>(
    `${ivyApiDomain}/api/v1/admin/users?name=${name}&page=${page}&size=${size}`,
    {
      headers: {
        X_IVY_ADMIN: token,
      },
    },
  );
};

export const fetchAdminUserResumes = (token: string, id: number) => {
  return RepositoryUtils.axiosGet<AdminResumeType>(
    `${ivyApiDomain}/api/v1/admin/resumes/${id}`,
    // `api/v1/admin/resumes/${id}`,
    {
      headers: {
        X_IVY_ADMIN: token,
      },
    },
  );
};

export const updateAdminResumeScore = (id: number, token: string, score: number) => {
  return RepositoryUtils.axiosPut<IvyUsersMeType>(
    `${ivyApiDomain}/api/v1/admin/resumes/${id}/score`,
    {
      score: score,
    },
    {
      headers: {
        X_IVY_ADMIN: token,
      },
    },
  );
};

export const uploadAdminImage = (token: string, file: File) => {
  return RepositoryUtils.axiosPost<MedeaType>(
    `${ivyApiDomain}/api/v1/media`,
    {
      file: file,
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        X_IVY_ADMIN: token,
      },
    },
  );
};

export const fetchAdminCompanyList = (title: string, page: number, size: number, token: string) => {
  return RepositoryUtils.axiosGet<AdminCompanyListResponseType>(
      `${ivyApiDomain}/api/v1/admin/company?name=${title}&page=${page}&size=${size}&isDeleted=false`,
      {
        headers: {
          X_IVY_ADMIN: token,
        },
      },
  );
};

export const getAdminCompany = (id: string, token: string) => {
    return RepositoryUtils.axiosGet<AdminCompanyInfoType>(
        `${ivyApiDomain}/api/v1/admin/company/${id}`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const registerAdminCompany = (companyInfo: AdminCompanyInfoType, token: string) => {
    return RepositoryUtils.axiosPost<AdminCompanyEditResponseType, ErrorType>(
        `${ivyApiDomain}/api/v1/admin/company`,
        {
                ...companyInfo
        },
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const editAdminCompanyList = (id: string, companyInfo: AdminCompanyInfoType, token: string) => {
    return RepositoryUtils.axiosPut<AdminCompanyEditResponseType>(
        `${ivyApiDomain}/api/v1/admin/company/${id}`,
        {
            ...companyInfo
        },
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const deleteAdminCompanyList = (id: string, token: string) => {
    return RepositoryUtils.axiosDelete<AdminCompanyEditResponseType>(
        `${ivyApiDomain}/api/v1/admin/company/${id}`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const fetchAdminRecruitmentList = (title: string, page: number, size: number, token: string) => {
    return RepositoryUtils.axiosGet<AdminRecruitmentResultType>(
        `${ivyApiDomain}/api/v1/admin/jobs?title=${title}&page=${page}&size=${size}&isDeleted=false`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const getAdminRecruitment = (id: string, token: string) => {
    return RepositoryUtils.axiosGet<AdminRecruitmentType>(
        `${ivyApiDomain}/api/v1/admin/jobs/${id}`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const registerAdminRecruitment = (recruitmentInfo: AdminRecruitmentRegisterType, token: string) => {
    return RepositoryUtils.axiosPost<AdminRecruitmentEditResponseType, ErrorType>(
        `${ivyApiDomain}/api/v1/admin/jobs`,
        {
            ...recruitmentInfo
        },
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const editAdminRecruitmentList = (id: string, recruitmentInfo: AdminRecruitmentRegisterType, token: string) => {
    return RepositoryUtils.axiosPut<AdminRecruitmentEditResponseType>(
        `${ivyApiDomain}/api/v1/admin/jobs/${id}`,
        {
            ...recruitmentInfo
        },
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const deleteAdminRecruitmentList = (id: string, token: string) => {
    return RepositoryUtils.axiosDelete<AdminRecruitmentEditResponseType>(
        `${ivyApiDomain}/api/v1/admin/jobs/${id}`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const getAdminRegions = (name: string, page: number, size: number, token: string) => {
    return RepositoryUtils.axiosGet<AdminRegionResultType>(
        `${ivyApiDomain}/api/v1/admin/jobs/regions?name=${name}&page=${page}&size=${size}`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};

export const getAdminOccupations = (name: string, page: number, size: number, token: string) => {
    return RepositoryUtils.axiosGet<AdminOccupationResultType>(
        `${ivyApiDomain}/api/v1/admin/jobs/occupations?name=${name}&page=${page}&size=${size}`,
        {
            headers: {
                X_IVY_ADMIN: token,
            },
        },
    );
};
